







































import { Component, Prop, Vue } from 'vue-property-decorator'
import { ProjectService as _projectService } from '@/services/project.service'
import { ProjectAttachmentRequestDto } from '@/models/dtos/projectAttachmentRequestDto'

@Component
export default class ProjectFileUploadModal extends Vue {
  // Data
  private projectId: string = '';
  private files: ProjectAttachmentRequestDto[] = []

  // Methods

  private remove(index: number) {
    this.files.splice(index, 1)
  }

  private showModal() {
    this.files = []
    this.$bvModal.show('project-file-upload-modal')
  }

  private changeFileList(fileList: FileList) {
    for (let i = 0; i < fileList.length; i++) {
      this.files.push({
        file: fileList[i],
        name: fileList[i].name,
        description: ''
      })
    }
  }

  private async uploadFiles() {
    const tmp = await _projectService.uploadProjectFile(this.prepareFormData(), this.projectId)
    this.$emit('save')
    this.$root.$emit('saved-project-attachments')
  }

  // Utili

  private prepareFormData(): FormData {
    const formData = new FormData()

    for (let i = 0; i < this.files.length; i++) {
      const currentFile = this.files[i]
      const file = currentFile.file
      const name = currentFile.name
      const description = currentFile.description

      formData.append(`file[${i}]`, file, name)
      formData.append(`name[${i}]`, name)
      formData.append(`description[${i}]`, description)
    }

    return formData
  }

  // Lifecycle
  created() {
    this.$root.$on('show-project-file-upload-modal', (projectId: string) => {
      this.projectId = projectId
      this.showModal()
    })
  }
}
